import { SearchState } from 'src/hooks/meilisearch/types/search-state';

export const bookingRulesKeys = {
  all: ['booking-rules'] as const,
  lists: () => [...bookingRulesKeys.all, 'list'] as const,
  list: (
    directoryToken: string,
    page: number,
    perPage: number,
    searchState?: SearchState,
  ) =>
    [
      ...bookingRulesKeys.lists(),
      directoryToken,
      { page, perPage, ...searchState },
    ] as const,
  details: () => [...bookingRulesKeys.all, 'detail'] as const,
  detail: (token: string) => [...bookingRulesKeys.details(), token] as const,
};
